module.exports = __webpack_public_path__ + "img/logo_monitoreo_comunitario_ppd.7be21f79.png";